package com.playoffpulse.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class AnalyticsEventName {
    ROUTE_VIEW,
    SHARE_URL_COPIED,
    INITIAL_TEAM_LOADED,
    TEAM_SELECTED,
    IMPORTANT_GAMES_TAB_VIEWED,
    LOAD_FAILED,
    STALE_SNAPSHOT_SEEN,
}

@Serializable
enum class AnalyticsFailureSource {
    STANDINGS,
    TEAM_LOAD,
    IMPORTANT_GAMES,
    REFRESH,
    UNKNOWN,
}

@Serializable
enum class AnalyticsPageKind {
    TEAM,
    MOVEMENT,
    STANDINGS,
    CHARTS,
    FAQ,
    ABOUT,
    SIGNAL,
}

@Serializable
data class AnalyticsEventRequest(
    val name: AnalyticsEventName,
    val league: LeagueId = LeagueId.NHL,
    val teamId: String? = null,
    val attributedTeamId: String? = null,
    val pageKind: AnalyticsPageKind? = null,
    val window: ImportantGamesWindow? = null,
    val failureSource: AnalyticsFailureSource? = null,
)

@Serializable
data class AnalyticsTrackResponse(
    val status: String = "ACCEPTED",
)
